import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EzidebitAchPage } from './ezidebit-ach.page';

const routes: Routes = [
  {
    path: '',
    component: EzidebitAchPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EzidebitAchPageRoutingModule {}
